var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass:
        "flex items-center justify-center gap-1 w-full focus:outline-none",
      attrs: { type: "button", processing: _vm.processing },
      on: {
        click: function ($event) {
          return _vm.$emit("resendInvitationClicked")
        },
      },
    },
    [
      _c("img", {
        staticClass: "h-5 w-5",
        attrs: { src: require("@/assets/up-right-icon.svg"), alt: "resend" },
      }),
      _c("span", { staticClass: "invite-text" }, [_vm._v("Resend invite")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }